import React from "react";
import { SimpleLineTrashIcon } from "modules/icons";
import useStyles from "./styles";

export const DeleteIcon: React.FC = () => {
  const { classes } = useStyles();

  return <SimpleLineTrashIcon className={classes.icon} />;
};
